import { createSelector } from '@reduxjs/toolkit'
import {
  accountsNotificationSelector,
  accountsValidationsErrorsSelector,
  commonNotificationSelector,
  commonValidationsErrorsSelector,
  positionNotificationSelector,
  positionValidationsErrorsSelector,
  toolsNotificationSelector,
  toolsValidationsErrorsSelector,
  userNotificationSelector,
  userValidationsErrorsSelector,
} from '@repo/catalogs-store'
import { GenericOperationState } from '@repo/core'

const hasDoneWithoutErrors = <T>(state: GenericOperationState<T>) => {
  return state.meta.fetchState === 'done' && !state.error
}

export const isLoadCatalogsDoneWithoutErrorsSelector = createSelector(
  [
    accountsNotificationSelector.rootSelector,
    commonNotificationSelector.rootSelector,
    positionNotificationSelector.rootSelector,
    toolsNotificationSelector.rootSelector,
    userNotificationSelector.rootSelector,
    accountsValidationsErrorsSelector.rootSelector,
    commonValidationsErrorsSelector.rootSelector,
    positionValidationsErrorsSelector.rootSelector,
    toolsValidationsErrorsSelector.rootSelector,
    userValidationsErrorsSelector.rootSelector,
  ],
  (
    accountsNotification,
    commonNotification,
    positionNotification,
    toolsNotification,
    userNotification,
    accountsValidationsErrors,
    commonValidationsErrors,
    positionValidationsErrors,
    toolsValidationsErrors,
    userValidationsErrors,
  ) => {
    return (
      hasDoneWithoutErrors(accountsNotification) &&
      hasDoneWithoutErrors(commonNotification) &&
      hasDoneWithoutErrors(positionNotification) &&
      hasDoneWithoutErrors(toolsNotification) &&
      hasDoneWithoutErrors(userNotification) &&
      hasDoneWithoutErrors(accountsValidationsErrors) &&
      hasDoneWithoutErrors(commonValidationsErrors) &&
      hasDoneWithoutErrors(positionValidationsErrors) &&
      hasDoneWithoutErrors(toolsValidationsErrors) &&
      hasDoneWithoutErrors(userValidationsErrors)
    )
  },
)
